module.exports = __webpack_public_path__ + "static/media/smoking-ban.37cb3ccb.svg";